module.exports = __webpack_public_path__ + "static/media/logoWithText.9f631986.svg";